import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import CheckMarkIcon from './check-mark.svg'
import {useStore} from './column-color-picker-store'

const TwIcon = tw(CheckMarkIcon)`
  text-invert
  absolute
  top-1/2
  left-1/2
  transform
  -translate-x-1/2
  -translate-y-1/2
  mt-[.5px]
`

const TwCircle = tw.div`
  w-16
  h-16
  rounded-full
`

const TwColor = tw.div`
  cursor-pointer
  relative
  w-24
  h-24
  p-4
  -m-4
  rounded-full
  flex
  items-center
  justify-center
`

export const ColumnColorItem = observer(
  ({hue, color}: {hue: number; color: string}) => {
    const [state, store] = useStore()
    const isSelected = hue === state.selected.hue

    return (
      <TwColor onClick={() => store.setSelected({hue})}>
        <TwCircle style={{background: color}} />
        {isSelected && <TwIcon />}
      </TwColor>
    )
  }
)
